import { render, staticRenderFns } from "./ConfirmEmail.vue?vue&type=template&id=79104056&scoped=true&"
import script from "./ConfirmEmail.vue?vue&type=script&lang=ts&"
export * from "./ConfirmEmail.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmEmail.vue?vue&type=style&index=0&id=79104056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79104056",
  null
  
)

export default component.exports